import withAuthentication from '@on3/ui-lib/src/hocs/withAuthentication';
import withValidUrl from '@on3/ui-lib/src/hocs/withValidUrl';
import { getFulfilledValue, proxyApi } from '@on3/ui-lib/utils/api';
import { NoSidebarLayout } from 'components/Layouts/NoSidebarLayout';
import { PageWrapper } from 'components/Layouts/PageWrapper';
import { type PageProps, StaticPage } from 'components/Page/StaticPage';
import type { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';

const NetworkStaticPage = ({ staticPage, ...props }: PageProps) => {
  const router = useRouter();

  return (
    <PageWrapper
      {...props}
      canonical={`https://www.on3.com/page/${router.query.slug}/`}
      description={`${staticPage?.title} from on3.com`}
      hideAds
      title={staticPage?.title || 'title'}
    >
      <NoSidebarLayout>
        {staticPage && <StaticPage data={staticPage} />}
      </NoSidebarLayout>
    </PageWrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData) {
    return {
      notFound: true,
    };
  }

  const { slug } = ctx.query;

  try {
    const [staticPage] = await Promise.allSettled([
      proxyApi
        .get(`/sites/v1/pages/`, { params: { pageSlug: slug } })
        .then((r) => r.data),
    ]);
    const data = {
      pageType: 'page',
      siteData,
      userData: userData || {},
      staticPage: getFulfilledValue(staticPage),
    };

    return { props: { ...data } };
  } catch (e) {
    return { props: {} };
  }
};

export default withValidUrl(NetworkStaticPage);
